import clsx from "clsx";
import React, { FC } from "react";

import { CommonColors } from "../../types/colors";
import { TabPanel } from "./tab-panel";
import { TabsProvider } from "./tabs-context";
import { TabsHeaders } from "./tabs-headers";
import { TabProps, TabsVariants } from "./types";
import { colorScheme as squaredColors } from "./variants/squared/styles";

export interface TabsProps {
  tabs: TabProps[];
  initialTab?: string;
  bodyClassName?: string;
  searchParamKey?: string | null;
  variant?: TabsVariants;
  colorScheme?: CommonColors;
  title?: string | null;
}

export const Tabs: FC<TabsProps> = ({
  tabs,
  initialTab,
  bodyClassName,
  searchParamKey,
  variant = TabsVariants.Pill,
  colorScheme = CommonColors.Light,
  title,
}) => {
  return (
    <div
      className={clsx(
        variant === TabsVariants.Squared
          ? ["pb-16", squaredColors[colorScheme].activeColor]
          : "py-16"
      )}
    >
      {title && (
        <div className="text-center text-3xl lg:text-5xl text-primary font-medium px-8 lg:px-20 w-full mb-8">
          {title}
        </div>
      )}
      <TabsProvider initialTab={initialTab ?? tabs[0]?.id} searchParamKey={searchParamKey}>
        <TabsHeaders tabs={tabs} variant={variant} colorScheme={colorScheme} />
        <div className={bodyClassName}>
          {tabs.map(({ id, body }) => (
            <TabPanel key={id} id={id}>
              {body}
            </TabPanel>
          ))}
        </div>
      </TabsProvider>
    </div>
  );
};
